export const ROUTING = {
  register: '/',
  back: '/powrot'
}
